import { render, staticRenderFns } from "./ctrl-year-month.vue?vue&type=template&id=051b52d4&scoped=true&"
import script from "./ctrl-year-month.vue?vue&type=script&lang=js&"
export * from "./ctrl-year-month.vue?vue&type=script&lang=js&"
import style0 from "./ctrl-year-month.vue?vue&type=style&index=0&id=051b52d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051b52d4",
  null
  
)

export default component.exports